<template>
<!-- строим содержимое только если пользователь аутентифицирован -->
<div v-if="this.$store.state.is_auth">
	<!-- если нет никаких ошибок -->
	<template v-if="!form_ErrorMessage">
		<!-- категории -->
		<div v-for="(obj, idx) in category" class="report-list-category" :class="{ 'first': idx === 0 }">
			<template v-if="obj.reports && obj.reports.length">
				<font-awesome-icon v-if="!obj.isOpen" icon="chevron-right" />
				<font-awesome-icon v-else icon="chevron-down" />
			</template>
			<span @click="handleOpen(obj.group_id)" class="w5-link menu"> &nbsp;{{ obj.group_name | ftc }}</span>
			<div v-if="obj.isOpen && obj.reports && obj.reports.length" class="report-list-subcategory-list">
				<template v-for="(rep, i) in obj.reports">
					<linkComponent
						class="report" :class="{ 'last': i === obj.reports.length - 1 }"
						:url="'/' + crud + '/view/' + rep.chart_id"
						:text="rep.chart_name"
						/>
					<br v-if="i >= 0" />
				</template>
			</div>
		</div>
	</template>
	<errorAlert v-else :message="form_ErrorMessage" />	
</div>			
</template>
<script>
import mixins from '@/mixins'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование
	//=========================================================================
	name: 'ReportList',
	//=========================================================================
	// mixin'ы
	//=========================================================================
	mixins: [mixins],
	//=========================================================================
	// данные
	//=========================================================================
	data() {
		return {
			// CRUD
			crud: 'chart',
			// закешированные данные - категории отчетов
			category: []
		}
	},
	//=========================================================================
	//  вычисляемые неизменяемые переменные
	//=========================================================================
	computed: {
		// конфигурация
		Config() {
			if (this.$store.state.user_type === 'client') return this.$store.state.clientConfig
			else if (this.$store.state.user_type === 'admin') return this.$store.state.adminConfig
			else return false
		},
		// конфигурация списка
		listConfig() {
			if (this.crud && this.Config && this.Config[this.crud] && this.Config[this.crud]['list']) return this.Config[this.crud]['list']
			return false
		}
	},
	//=========================================================================
	// создание
	//=========================================================================
	created() {
		// если не авторизован - редирект на страницу логина
		if (!this.$store.state.is_auth)
		{
			// сброс аутентификации
			this.$store.commit('dropAuth')
			// запоминаем URL, что бы к нему вернуться
			this.$store.commit('setReturnURL', this.$route.path)
			// остановим Push-систему
			this.$store.commit('pushStop')
			// делаем редирект
			return this.$router.push('/login')
		}

		// запрос данных
		this.requestData()
	},
	//=========================================================================
	// локальные методы компонента
	//=========================================================================
	methods: {
		// закрытие/раскрытие спика
		handleOpen(groupId) {
			this.category.some(item => {
				if (item.group_id === groupId)
				{
					item.isOpen = !item.isOpen
					this.setLocalStorage()
					return true
				}
			})
		},
		// запрос списка
		requestData() {
			// теперь точно можно делать запрос
			this.forms_Get('/' + this.crud + '/list', {},
				// успешно получили данные
				data => {
					this.category = []

					if (data && data.status === 'ok' &&
						data.filters && data.filters.chart_group &&
						data.rows && data.title &&
						data.filters.chart_group.list &&
						typeof data.filters.chart_group.list === 'object' &&
						Object.keys(data.filters.chart_group.list).length)
					{
						for (let groupId in data.filters.chart_group.list)
						{
							this.category.push({
								group_id: groupId,
								group_name: data.filters.chart_group.list[groupId],
								isOpen: false,
								reports: []
							})
						}

						for (let idx in this.category)
						{
							let groupId = this.category[idx]['group_id']
							data.rows.forEach(item => {
								if (item['chart_group'] === groupId)
								{
									this.category[idx]['reports'].push({
										chart_id: item['chart_id'],
										chart_name: item['chart_name']
									})
								}
							})
						}

						this.getLocalStorage()
					}
				}
			)
		},
		// восстановим состояние категорий из localStorage
		getLocalStorage() {
			// генерируем ключ в хранилище
			let _key = 'w5_' + this.$store.state.user_id + '_reportlist'

			// смотрим в хранилище
			let data = this.$store.state.userServerOptions && this.$store.state.userServerOptions[_key]
				? this.$store.state.userServerOptions[_key] : ''

			// проверки
			if (!data && !window.localStorage)
			{
				if (this.$store.state.isDebug) window.DEBUG.error('localStorage недоступен')
				return false
			}

			if (!this.$store.state.user_id)
			{
				if (this.$store.state.isDebug) window.DEBUG.error('пользователь не авторизован')
				return false
			}

			let _json = null
			if (data)
			{
				_json = data
			}
			else
			{
				// считаем данные из localStorage
				_json = window.localStorage.getItem(_key)
				if (!_json) return true
			}

			try {
				// парсим JSON
				let _data = JSON.parse(_json)

				// установим данные
				if (_data && typeof _data === 'object' && Array.isArray(_data))
				{
					this.category.forEach(item => {
						if (_data.indexOf(item.group_id) > -1) item.isOpen = true
						else item.isOpen = false
					})
				}
			}
			catch (_err)
			{
				if (this.$store.state.isDebug) window.DEBUG.error(_err.name + ': ' + _err.message)
				return false
			}

			return true
		},
		// сохраним состояние в localStorage
		setLocalStorage() {
			// проверки
			if (!window.localStorage)
			{
				if (this.$store.state.isDebug) window.DEBUG.error('localStorage недоступен')
				return false
			}

			if (!this.$store.state.user_id)
			{
				if (this.$store.state.isDebug) window.DEBUG.error('пользователь не авторизован')
				return false
			}

			// сохраняем только открытые категории
			let open = []
			this.category.forEach(item => {
				if (item.isOpen) open.push(item.group_id)
			})

			// генерируем ключ в хранилище
			let _key = 'w5_' + this.$store.state.user_id + '_reportlist'

			// все храним в виде строки
			let _modelString = JSON.stringify(open)

			// записываем данные
			try {
				// в удаленное хранилище
				this.remoteStorageSet(_key, _modelString)
				// обновляем в хранилище
				this.$store.commit('updateUserOptionsOnServer', {
					key: _key,
					value: _modelString
				})
				// в localStorage
				window.localStorage.setItem(_key, _modelString)
			}
			catch (_err)
			{
				if (this.$store.state.isDebug) window.DEBUG.error(_err.name + ': ' + _err.message)
				return false
			}

			return true
		}
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style scoped>
div.report-list-category {
	width: 100%;
	padding: 5px 15px;
	border: 1px solid #ddd;
	margin-bottom: 15px;
	border-radius: 4px;
	font-weight: 500;
}

div.report-list-category.first {
	margin-top: 20px;
}

div.report-list-category > span.menu {
	user-select: none;
	cursor: pointer;
}

div.report-list-category > svg {
	font-size: 10px;
	width: 12px;
	height: 12px;
}

div.report-list-subcategory-list {
}

a.report, span.report {
	display: inline-block;
	margin-top: 10px;
	margin-left: 20px;
	font-size: 13px;
	font-weight: 300;
}

a.report.last, span.report.last {
	margin-bottom: 10px;
}

</style>



// WEBPACK FOOTER //
// ReportList.vue?baaf682a